export default __webpack_public_path__ + "static/media/1 -Dorota EMIGRACJA XD .7ac230a4.jpg";